export default __webpack_public_path__ + "static/media/rhenus-can.368e28c5.svg";